const translations = {
  "en": {
    "neutral": "neutral",
    "overbought": "overbought",
    "oversold": "oversold"
  },
  "zh-tw": {
    "neutral": "中立",
    "overbought": "超買",
    "oversold": "超賣"
  }
};

export default translations;
